export const isClassPreview = (url: string): boolean => {
    return url.includes("class_preview") || url.includes("class-preview");
};